// extracted by mini-css-extract-plugin
export default {"main":"NewsListPage_main__eFixz","content":"NewsListPage_content__2J+MM","title":"NewsListPage_title__3SQPB"};